/**
 * @author        yewon@zumper.com (Yewon Lee)
 * @copyright     Copyright (c) 2018, Zumper
 * @description   index.js
 */

import { filterActions } from '@zumper/redux-ignore'
import * as constants from './constants'
import rootReducer from './reducers'

const whitelist = Object.values(constants)

export { whitelist }
export default filterActions(rootReducer, whitelist)
